import React from "react";
import { Modal } from "react-bootstrap";
import { ActionButton } from "../../../../../_metronic/_partials/controls/ActionButton";

export default function ConfirmationDeleteModal({
  show,
  onHide,
  title,
  loading = false,
  content,
  onClick
}) {
  return (
    <div>
      <Modal
        size="md"
        show={show}
        centered
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: "64px", color: "#F23013" }}
            ></i>
          </div>
          <div className="mt-8 text-center">
            <strong>{content}</strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={onHide}
              className="btn btn-light btn-elevate mr-3"
            >
              Cancel
            </button>
            <ActionButton
              type="button"
              onClick={onClick}
              loading={loading}
              className="btn btn-primary btn-elevate"
            />
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
